/** Small layout fixes; no product data, section content or payment code changes. */
(() => {
  if (window.__buddhaRefinements) return;
  window.__buddhaRefinements = true;

  let scheduled = false;
  let chatLift = 0;
  const mobile = window.matchMedia('(max-width: 749px)');
  const overlaps = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;

  function syncStickyLabel() {
    const sticky = document.querySelector('.sticky-add-to-cart__button');
    const main = document.querySelector('product-form-component button[name="add"]');
    if (!sticky || !main) return;
    const text = main.querySelector('.add-to-cart-text__content')?.textContent?.trim()
      || main.getAttribute('aria-label')
      || main.textContent.trim();
    if (text && sticky.getAttribute('aria-label') !== text) sticky.setAttribute('aria-label', text);
  }

  function positionChat() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const controlsVisible = [...document.querySelectorAll('jewelry-personalization, memorial-personalization, .product-form-buttons, .sticky-add-to-cart__bar, .cart__ctas')]
      .some(element => {
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportHeight
          && style.visibility !== 'hidden' && style.opacity !== '0';
      });
    const inputFocused = document.activeElement?.matches('input:not([type="checkbox"], [type="radio"], [type="hidden"]), textarea, select');
    chat.toggleAttribute('data-mobile-controls-active', mobile.matches && !chat.hasAttribute('open') && (controlsVisible || inputFocused));
    const activator = chat.shadowRoot?.querySelector('[part~="activator"]')
      || chat.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
    if (!activator) return;
    let lift = 0;
    if (mobile.matches && !chat.hasAttribute('open') && !document.querySelector('dialog[open], .menu-drawer-container[open]')) {
      const rect = activator.getBoundingClientRect();
      const base = {left: rect.left, right: rect.right, top: rect.top + chatLift, bottom: rect.bottom + chatLift};
      const obstacles = [...document.querySelectorAll('.product-form-buttons, variant-picker, .sticky-add-to-cart__bar, media-gallery .slideshow-controls__thumbnails')]
        .filter(element => {
          const style = getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        })
        .map(element => element.getBoundingClientRect())
        .filter(r => r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < viewportHeight)
        .sort((a, b) => b.top - a.top);
      let candidate = {...base};
      for (const obstacle of obstacles) {
        if (overlaps(candidate, obstacle)) {
          const height = candidate.bottom - candidate.top;
          candidate.bottom = obstacle.top - 12;
          candidate.top = candidate.bottom - height;
        }
      }
      const headerBottom = Math.max(0, document.querySelector('#header-component')?.getBoundingClientRect().bottom || 0);
      lift = Math.max(0, Math.min(base.top - candidate.top, base.top - headerBottom - 12));
    }
    if (Math.abs(lift - chatLift) > 0.5) {
      chatLift = lift;
      chat.style.setProperty('--buddha-chat-lift', `${Math.round(lift)}px`);
    }
  }

  function update() {
    scheduled = false;
    syncStickyLabel();
    positionChat();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('load', schedule, {once: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  document.querySelector('.page-wrapper')?.addEventListener('scroll', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  mobile.addEventListener('change', schedule);

  const sticky = document.querySelector('sticky-add-to-cart');
  if (sticky) new MutationObserver(schedule).observe(sticky, {attributes: true, attributeFilter: ['data-variant-available', 'data-stuck']});
  const stickyBar = sticky?.querySelector('.sticky-add-to-cart__bar');
  if (stickyBar) new MutationObserver(schedule).observe(stickyBar, {attributes: true, attributeFilter: ['data-stuck']});
  const form = document.querySelector('product-form-component');
  if (form) new MutationObserver(schedule).observe(form, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
  if ('ResizeObserver' in window && form) new ResizeObserver(schedule).observe(form);
  customElements.whenDefined('shopify-chat').then(() => {
    const chat = document.querySelector('shopify-chat');
    if (chat) new MutationObserver(schedule).observe(chat, {attributes: true, attributeFilter: ['open', 'mode']});
    if (chat?.shadowRoot) new MutationObserver(schedule).observe(chat.shadowRoot, {childList: true, subtree: true});
    schedule();
  });
  schedule();
})();
